import marked from 'marked';

export default function TableComponent({ value }) {
  const headers = value.rows[0].cells;
  const rows = value.rows.slice(1);

  return (
    <div className="overflow-x-auto not-prose text-base w-full">
      <table className="table-fixed w-full">
        <thead>
          <tr>
            {headers.map((header, i) => {
              return (
                <th key={i} className="border border-gray-300 p-2 text-left">
                  {parseMarkdown(header)}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {rows.map((row, i) => {
            return (
              <tr key={i}>
                {row.cells.map((cell, j) => {
                  return (
                    <td key={j} className="border border-gray-300 p-2">
                      {parseMarkdown(cell)}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function parseMarkdown(text) {
  if (!text) return text;

  marked.setOptions({
    breaks: true,
    gfm: true,
  });

  // Parse the markdown text to HTML
  // This will handle:
  // - **bold text** or __bold text__
  // - *italic text* or _italic text_
  // - [links](https://example.com)
  // - And other markdown features
  const html = marked.parse(text || '');

  // Return the HTML wrapped in a dangerouslySetInnerHTML object for React
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}
